<template>
  <ValidationObserver ref="observer"
                      v-slot="{ dirty, pristine, valid, invalid, pending, touched, untouched, passed, failed, errors, validate, validateWithInfo, handleSubmit, reset }"
                      :disabled="validateDisabled"
                      :vid="validateVid"
                      slim
  >
    <b-form v-bind="$attrs" @submit.prevent="submit()">
      <slot v-bind="{ dirty, pristine, valid, invalid, pending, touched, untouched, passed, failed, errors, validate, validateWithInfo, handleSubmit, reset }"/>
    </b-form>
  </ValidationObserver>
</template>

<script>
export default {
  name: "CForm",
  props: {
    validateDisabled: Boolean,
    validateVid: String,
  },
  methods: {
    submit() {
      this.$refs.observer.validate().then(isSuccess => {
        if (isSuccess) {
          this.$emit("submit");
        }
      })
    },
    reset() {
      this.$refs.observer.reset();
    },
    setErrors(errors) {
      this.$refs.observer.setErrors(errors);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.observer.validate()
            .then(isSuccess => {
              if (isSuccess) {
                resolve(true);
              } else {
                reject(false);
              }
            })
            .catch(reason => {
              reject(reason);
            })
      })
    }
  }
}
</script>

<style scoped>

</style>